import React from 'react'
import { Link } from "gatsby"
import Photo1 from '../assets/PhotoSF/Pt31-removebg-preview.png'
import Photo2 from '../assets/PhotoSF/Pt33-removebg-preview.png'
import Photo3 from '../assets/PhotoSF/Pt43-removebg-preview.png'

const Card6 = () => {
    return (
		<div>
			<p className='p-20'></p>
			<div className=' w-full color-al-4 py-6 px-6 sm:flex  sm:space-x-5 space-y-3'>
				
				<p></p>
				<div className='py-1 px-2 w-full max-w-sm bg-white shadow-md rounded'>
					<div className="">
						<div className="font-bold font-al-7 text-xl mb-2"><p>Bolos - especias</p></div>
							<p className="text-gray-700 text-base">
								
							</p>
						</div>
							<Link to={`/pageclients`}>
								<img className='w-auto animation-ronsof-one' src={Photo1} alt='card5' />       
							</Link> 
						
				</div>

				<div className='py-1 px-2 w-full max-w-sm bg-white shadow-md rounded'>
					<div className="">
						<div className="font-bold font-al-7 text-xl mb-2"><p>Bolos - Casamentos</p></div>
							<p className="text-gray-700 text-base">
								
							</p>
						</div>
							<Link to={`/pageclients`}>
								<img className='w-auto animation-ronsof-one' src={Photo2} alt='card5' />       
							</Link> 
						
				</div>

				<div className='py-1 px-2 w-full max-w-sm bg-white shadow-md rounded'>
					<div className="">
						<div className="font-bold font-al-7 text-xl mb-2"><p>Bolos -  Aniversário</p></div>
							<p className="text-gray-700 text-base">
								
							</p>
						</div>
							<Link to={`/pageclients`}>
								<img className='w-auto animation-ronsof-one' src={Photo3} alt='card5' />       
							</Link> 
						
				</div>
			
				
				
				
			</div>
		</div>
        
    )
}
export default Card6